import { useMemo, useState } from 'react';
import { Box, Tabs, Tab, Chip } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '../../stores/auth.store';
import { trackingService } from '../../services/tracking.service';
import { utcStamp } from '../../utils/timezone';
import ConversionsPage from './ConversionsPage';
import UnmatchedPostbacksTab from './UnmatchedPostbacksTab';

/** Conversions + an admin-only "Unmatched" tab (#221), gated to admins because the endpoint is. */
export default function ConversionsTabsPage() {
  const role = useAuthStore((s) => s.user?.role);
  const isAdmin = role === 'admin';
  const [tab, setTab] = useState(0);

  // 48h window, fixed once on mount so the query key stays stable (no refetch loop).
  const badgeWindow = useMemo(() => {
    const to = new Date();
    return { date_from: utcStamp(new Date(to.getTime() - 48 * 3600_000)), date_to: utcStamp(to) };
  }, []);
  const { data: badge } = useQuery({
    queryKey: ['unmatched-postbacks', 'badge', badgeWindow],
    queryFn: () => trackingService.getUnmatchedPostbacks({ ...badgeWindow, limit: 1 }),
    enabled: isAdmin,
  });

  if (!isAdmin) return <ConversionsPage />;

  return (
    <Box>
      <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}>
        <Tab label="Conversions" sx={{ textTransform: 'none' }} />
        <Tab
          sx={{ textTransform: 'none' }}
          iconPosition="end"
          icon={badge?.total ? <Chip size="small" color="error" label={badge.total > 999 ? '999+' : badge.total} /> : undefined}
          label="Unmatched"
        />
      </Tabs>
      {tab === 0 ? <ConversionsPage /> : <UnmatchedPostbacksTab />}
    </Box>
  );
}
